import { useState } from "react";
import { Box } from "@mui/material";
import DoneOutlinedIcon from "@mui/icons-material/DoneOutlined";
import "./styles.css";

const CustomSelectorChip = ({ setValue, options }) => {
  const [selectedOption, setSelectedOption] = useState(null);

  const handleOptionSelect = (index) => {
    setSelectedOption(index);
    setValue(options[index]);
  };

  return (
    <>
      {options.map((option, index) => (
        <Box
          key={index}
          onClick={() => {
            handleOptionSelect(index);
          }}
          className={`custom-selector-chip-container ${
            index === 0 ? "first" : "second"
          } ${selectedOption === index && "active"}`}
        >
          <Box className="options-container">
            <Box className="abbreviation-text">{option.abbreviation}</Box>
            <Box className="label-text">{option.label}</Box>
          </Box>
          <Box
            className={`custom-selector-checkbox-container ${
              selectedOption === index
                ? index === 0
                  ? "first"
                  : "second"
                : null
            }`}
          >
            {selectedOption === index && (
              <DoneOutlinedIcon
                className={`custom-selector-checkbox ${
                  index === 0 ? "first" : "second"
                }`}
              />
            )}
          </Box>
        </Box>
      ))}
    </>
  );
};

export default CustomSelectorChip;
